import $ from "jquery";
import template from "./template.html";
import galleryTemplate from "./gallery_template.html";

export function modal(url, title) {
    let m = document.createElement("div");
    m.id = "fp_modal";
    m.className = "modal";
    m.innerHTML = template({url, title});

    let $m = $(m);

    $m.on("hidden.bs.modal", () => document.body.removeChild(m));
    $m.modal("show");
}

export function galleryModal(imgs, idx, title) {
    let m = document.createElement("div");
    m.id = "fp_modal";
    m.className = "modal";
    m.innerHTML = galleryTemplate({imgs, idx, title});

    let $m = $(m);

    $m.on("hidden.bs.modal", () => document.body.removeChild(m));
    $m.on("shown.bs.modal", () => $m.find("#fp_modal_gallery").carousel());
    $m.modal("show");
}

export function contactFormModal(floorplan, unit) {
    const m = document.getElementById("modal_notify_me");

    const $m = $(m);

    const display_bed = floorplan.get("display_bed");

    $m.find("#modal_control_notify_me_category").val(display_bed);
    $m.find("#modal_control_notify_me_floorplan").val(floorplan.get("name"));

    $m.find(".bedroom_list").val(display_bed);
    $m.find(".bedroom_list").prop("disabled", true);

    if (unit) {
        $m.find("#modal_control_notify_me_unit").val(unit.get("number"));
        $m.find("#modal_control_notify_me_available").val(unit.get("available_date"));
        $m.find("#modal_label_notify_me_unit, #modal_label_notify_me_available").show();
    } else {
        $m.find("#modal_label_notify_me_unit, #modal_label_notify_me_available").hide();
    }

    $m.find(".date_input").attr("autocomplete", "off");
    $m.find(".date_input").pickadate({
        format: "yyyy-mm-dd",
        min: true,
        closeOnSelect: true,
    });

    $m.on("show.bs.modal", () => {
        const selectedDate = $("#movein_date").val();

        $m.find(".date_input").val(selectedDate);
        $m.find("#modal_control_apply_now_name").focus();
    });

    $m.on("hidden.bs.modal", () => {
        $m.find("[data-slug='leads']").each(function() {
            this.reset();
        });

        if ($m.find("#djenga-form-leads").children("p").length) {
            window.location.reload();
        }

        $m.find("#modal_notify_me .modal_error").html("").hide();
    });

    $m.find("#button_submit_notify_me").on("click", function(e) {
        $m.find("#modal_notify_me .modal_error").html("").hide();

        const contact_form_url = `/api/v2/comment/?format=json&api_key=${window.api_key}`;

        const contact_form_data = {
            "csrfmiddlewaretoken":"",
            "name": $m.find("#modal_control_notify_me_name").val(),
            "email": $m.find("#modal_control_notify_me_email").val(),
            "phone":"",
            "preferred_method_of_contact":"email",
            "desired_type":"Any",
            "body": $m.find("#modal_control_notify_me_comment").val(),
            "ripple":"",
            "from_landing_page":"False",
            "storage":"",
            "opt_in_mailchimp":"False",
            "home":"",
            "ip_address":"127.0.0.1",
            "unit":"",
            "submit":"Submit",
            "move_in_date":"",
            "desired_bedrooms": "",
        };

        jQuery.ajax({
            type: "POST",
            contentType: "application/json",
            url: contact_form_url,
            data: JSON.stringify(contact_form_data),
            success: function(response){
                $m.modal("hide");
            },
            error: function(response) {
                $m.find("#modal_notify_me .modal_error")
                    .html("Oh no!  It looks like something went wrong when trying to send your information to us.  Please check your entries and try again!")
                    .show();
            }
        });
    });

    $m.modal("show");
}
